export default __webpack_public_path__ + "static/media/logo.b592dd11.png";